var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.5H17.75C13.75 2.5 11.25 5 11.25 9V14.0625H16.8L14.2125 11.475C14.025 11.2875 13.9375 11.05 13.9375 10.8125C13.9375 10.575 14.025 10.3375 14.2125 10.15C14.575 9.7875 15.175 9.7875 15.5375 10.15L19.725 14.3375C20.0875 14.7 20.0875 15.3 19.725 15.6625L15.5375 19.85C15.175 20.2125 14.575 20.2125 14.2125 19.85C13.85 19.4875 13.85 18.8875 14.2125 18.525L16.8 15.9375H11.25V21C11.25 25 13.75 27.5 17.75 27.5H20.9875C24.9875 27.5 27.4875 25 27.4875 21V9C27.5 5 25 2.5 21 2.5Z",
    fill: "#161F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 14.0625C2.925 14.0625 2.5 14.4875 2.5 15C2.5 15.5125 2.925 15.9375 3.4375 15.9375H11.25V14.0625H3.4375Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.78eed5da38638bfcc2676499e61aedc6.svg";
export { ForwardRef as ReactComponent };